import axios from 'axios';
const baseDomian = 'https://vapiano-test.herokuapp.com';
const baseURL = `${baseDomian}`;
let axiosObj;
axiosObj = axios.create({
  baseURL
});

export default axiosObj;
